import { useEffect, useMemo, useState } from "react";
const getSlideWidth = (windowWidth)=>windowWidth >= 1440 ? 452 : 386;
export const useNumberOfSlides = ()=>{
    const [windowWidth, setWindowWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 0);
    const numberOfSlides = useMemo(()=>{
        return windowWidth / getSlideWidth(windowWidth);
    }, [
        windowWidth
    ]);
    useEffect(()=>{
        const handleResize = ()=>setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return numberOfSlides;
};
